export const COMMON_TRANSLATIONS: Record<string, string> = {
  'Аккаунт': 'Account',
  'Активная перевозка': 'Active transport',
  'Активные': 'Active',
  'Активные перевозки': 'Active transports',
  'Воспроизвести видеоотзыв': 'Play video review',
  'Выйти из аккаунта': 'Log out',
  'Все': 'All',
  'В пути': 'In transit',
  'Войти': 'Log in',
  'Войти в LOVO': 'Log in to LOVO',
  'Главная': 'Home',
  'Готово': 'Done',
  'Далее': 'Continue',
  'Добавить': 'Add',
  'Документы': 'Documents',
  'Завершена': 'Completed',
  'Завершённые': 'Completed',
  'Загрузить': 'Upload',
  'Закрыть': 'Close',
  'Закрыть меню': 'Close menu',
  'Заявка': 'Request',
  'Заявки': 'Requests',
  'Кабинет': 'Account',
  'Кабинет заказчика': 'Customer account',
  'Кабинет перевозчика': 'Carrier account',
  'К списку заявок': 'Back to requests',
  'Как это работает': 'How it works',
  'Как работает рейтинг и верификация': 'How ratings and verification work',
  'Личный кабинет': 'Account',
  'Мобильная навигация': 'Mobile navigation',
  'Мобильное меню': 'Mobile menu',
  'Мои заявки': 'My requests',
  'На моём маршруте': 'On my route',
  'Назад': 'Back',
  'Навигация': 'Navigation',
  'Настройки': 'Settings',
  'Не удалось загрузить данные': 'Could not load data',
  'Нет данных': 'No data',
  'Новая заявка': 'New request',
  'Основная навигация': 'Main navigation',
  'Отмена': 'Cancel',
  'Отменена': 'Cancelled',
  'Отменённые': 'Cancelled',
  'Открыта': 'Open',
  'Открыть меню': 'Open menu',
  'Открыть': 'Open',
  'Отклик': 'Offer',
  'Отклики': 'Offers',
  'Перевозчик': 'Carrier',
  'Перевозчики': 'Carriers',
  'Перевозка': 'Transport',
  'Перевозки': 'Transports',
  'Пользователь удален': 'User deleted',
  'Перейти': 'Open',
  'Подтвердить': 'Confirm',
  'Подробнее': 'Details',
  'Помощь': 'Help',
  'Показать пароль': 'Show password',
  'Предыдущая': 'Previous',
  'Проверка': 'Review',
  'Шаг': 'Step',
  'Продолжить': 'Continue',
  'Профиль': 'Profile',
  'Редактировать': 'Edit',
  'Регистрация': 'Registration',
  'Сбросить': 'Reset',
  'Сменить': 'Change',
  'Сохранить': 'Save',
  'Скрыть пароль': 'Hide password',
  'Срочно': 'Urgent',
  'Следующая': 'Next',
  'Сообщение': 'Message',
  'Сообщения': 'Messages',
  'Ответить': 'Reply',
  'Стать перевозчиком': 'Become a carrier',
  'Удалить': 'Delete',
  'Уведомления': 'Notifications',
  'Управление безопасностью, способами входа и уведомлениями': 'Manage security, sign-in methods and notifications',
  'Фильтр заявок': 'Request filters',
  'Фото': 'Photos',
  'Чат': 'Chat',
  'Здесь скоро будут новые фото довольных питомцев ❤︎': 'New photos of happy pets are coming soon ❤︎',
  'Я заказчик': 'I am a customer',
  'Я перевозчик': 'I am a carrier',
  'Язык': 'Language',
  'Язык и регион': 'Language and region',
  'Язык интерфейса': 'Interface language',
  'Используется как валюта новых заявок и отображения сумм': 'Used for new requests and displaying amounts',
  'ИНН:': 'Tax ID:',
  'ОГРНИП:': 'Registration No.:',
  'Русский': 'Russian',
  'января': 'January',
  'февраля': 'February',
  'марта': 'March',
  'апреля': 'April',
  'мая': 'May',
  'июня': 'June',
  'июля': 'July',
  'августа': 'August',
  'сентября': 'September',
  'октября': 'October',
  'ноября': 'November',
  'декабря': 'December',
  'Активна': 'Active',
  'Активный': 'Active',
  'Черновик': 'Draft',
  'По предложению перевозчика': 'Carriers quote',
  'Договорная': 'Carriers quote',
  'Авто': 'Auto',
  'Авиа': 'Air',
  'Карго': 'Cargo',
  'Встреча': 'Meet',
  'Авиакурьер': 'Air courier',
  'Собака': 'Dog',
  'Кошка': 'Cat',
  'Птица': 'Bird',
  'Грызун': 'Rodent',
  'Сельхоз': 'Farm animal',
  'Другое': 'Other',
  'Метис': 'Mixed breed',
  'Овчарка': 'Shepherd',
  'Кавказская овчарка': 'Caucasian Shepherd',
  'Немецкая овчарка': 'German Shepherd',
  'Лабрадор': 'Labrador',
  'Мейн-кун': 'Maine Coon',
  'Йорк': 'Yorkie',
  'Йоркширский терьер': 'Yorkshire Terrier',
  'Хаски': 'Husky',
  'Бигль': 'Beagle',
  'Шпиц': 'Spitz',
  'Корги': 'Corgi',
  'Британская': 'British Shorthair',
  'Британская кошка': 'British Shorthair',
  'Сфинкс': 'Sphynx',
  'Беспородная': 'Mongrel',
  'Дворняжка': 'Mongrel',
  'Померанский шпиц': 'Pomeranian',
  'Французский бульдог': 'French Bulldog',
  'Мопс': 'Pug',
  'Чихуахуа': 'Chihuahua',
  'Джек-рассел': 'Jack Russell',
  'Пудель': 'Poodle',
  'Золотистый ретривер': 'Golden Retriever',
  'Ротвейлер': 'Rottweiler',
  'Доберман': 'Doberman',
  'Такса': 'Dachshund',
  'Сиамская': 'Siamese',
  'Шотландская вислоухая': 'Scottish Fold',
  'Бенгальская': 'Bengal',
  'Москва': 'Moscow',
  'Берлин': 'Berlin',
  'Минск': 'Minsk',
  'Сочи': 'Sochi',
  'Краснодар': 'Krasnodar',
  'Санкт-Петербург': 'Saint Petersburg',
  'СПб': 'St. Petersburg',
  'Тбилиси': 'Tbilisi',
  'Ереван': 'Yerevan',
  'Прага': 'Prague',
  'Варшава': 'Warsaw',
  'Будапешт': 'Budapest',
  'Франкфурт-на-Майне': 'Frankfurt',
  'Нижний Новгород': 'Nizhny Novgorod',
  'Казань': 'Kazan',
  'Екатеринбург': 'Yekaterinburg',
  'Новосибирск': 'Novosibirsk',
  'Алматы': 'Almaty',
  'Астана': 'Astana',
  'Ташкент': 'Tashkent',
  'Баку': 'Baku',
  'Белград': 'Belgrade',
  'Стамбул': 'Istanbul',
  'Анталья': 'Antalya',
  'Дубай': 'Dubai',
  'Рим': 'Rome',
  'Мадрид': 'Madrid',
  'Барселона': 'Barcelona',
  'Лиссабон': 'Lisbon',
  'Вена': 'Vienna',
  'Братислава': 'Bratislava',
  'Вильнюс': 'Vilnius',
  'Рига': 'Riga',
  'Таллин': 'Tallinn',
  'Хельсинки': 'Helsinki',
  'Париж': 'Paris',
  'Отзыв о перевозчике': 'Carrier review',
  'Отзыв о заказчике': 'Customer review',
  'Яндекс Карты': 'Yandex Maps',
  'Google Maps': 'Google Maps',
  'Согласована прямая оплата между заказчиком и перевозчиком.': 'Direct payment between customer and carrier was agreed.',
  'Заказчик отметил прямую оплату как оплаченную.': 'Customer marked direct payment as paid.',
  'Перевозчик подтвердил получение прямой оплаты.': 'Carrier confirmed direct payment receipt.',
  'Перевозчик начал перевозку.': 'Carrier started the transport.',
  'Перевозчик отметил перевозку как доставленную.': 'Carrier marked the transport as delivered.',
  'Перевозчик отметил доставку питомца.': 'Carrier marked the transport as delivered.',
  'Заказчик подтвердил получение питомца.': 'Customer confirmed receiving the pet.',
  'Direct payment between customer and carrier was agreed.': 'Direct payment between customer and carrier was agreed.',
  'Customer marked direct payment as paid.': 'Customer marked direct payment as paid.',
  'Carrier confirmed direct payment receipt.': 'Carrier confirmed direct payment receipt.',
  'Carrier started the transport.': 'Carrier started the transport.',
  'Carrier marked the transport as delivered.': 'Carrier marked the transport as delivered.',
  'Customer confirmed receiving the pet.': 'Customer confirmed receiving the pet.',
};
